export default "__VITE_ASSET__CrHYHFxp__"